/**
 * A list of available feature flag to check, (must match the feature flag key in PostHog).
 */
export const features = [
  'generate_document',
  'generate_document_summary',
  'generate_description_code',
  'document_gh_repo_search',
  'document_versions',
  'document_create_pr',
  'document_code_file_links',
  'document_review_comments',
  'code_links_note',
  'ai_chat_panel',
] as const;

export type FeatureFlag = (typeof features)[number];

/**
 * Validates a feature flag.
 *
 * @param feature A feature flag to check.
 */
export const validateFeatureFlag = (
  feature: string
): feature is FeatureFlag => {
  return features.includes(feature as FeatureFlag);
};

/**
 * Asserts that a feature flag is valid.
 *
 * @param feature A feature flag to check.
 */
export const assertFeatureFlag = (
  feature: string
): asserts feature is FeatureFlag => {
  if (!validateFeatureFlag(feature)) {
    throw new Error(`Invalid feature flag: ${feature}`);
  }
};
